import { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

export function useScrollEffects() {
  const { pathname } = useLocation();
  const [showBackToTop, setShowBackToTop] = useState(false);

  const resetAnimations = useCallback(() => {
    const cards = document.querySelectorAll('[data-animate]');
    cards.forEach((card) => {
      card.classList.add('opacity-0', 'translate-y-4');
      card.classList.remove('opacity-100', 'translate-y-0');
    });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('opacity-100', 'translate-y-0');
            entry.target.classList.remove('opacity-0', 'translate-y-4');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    cards.forEach((card) => observer.observe(card));

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    let observerCleanup;
    const frame = requestAnimationFrame(() => {
      observerCleanup = resetAnimations();
    });

    const handleScroll = () => {
      setShowBackToTop(window.scrollY > 400);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    return () => {
      cancelAnimationFrame(frame);
      observerCleanup?.();
      window.removeEventListener('scroll', handleScroll);
    };
  }, [pathname, resetAnimations]);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return {
    showBackToTop,
    scrollToTop,
    resetAnimations,
  };
}
